export const prefix = '/api/bo'

export const prepareUrl = (url, options) => {
  let _url = url
  Object.keys(options).forEach((k) => {
    const rx = new RegExp(`{${k}}`, 'i')
    _url = _url.replace(rx, options[k])
  })
  return _url
}

export const uri = {
  me: `${prefix}/me`,
  locked: `${prefix}/locked`,
  markets: `${prefix}/markets`,
  dashboard: {
    turnover: `${prefix}/dash/turnover`,
    clientTotals: `${prefix}/dash/client-totals`,
    twoDaysTotal: `${prefix}/dash/2d-total`,
    twoDaysChart: `${prefix}/dash/2d-chart`,
    sevenDays: `${prefix}/dash/7d`,
    sevenDaysTotal: `${prefix}/dash/7d-total`,
    sevenDaysChart: `${prefix}/dash/7d-chart`,
    thirtyDays: `${prefix}/dash/30d`,
    thirtyDaysTotal: `${prefix}/dash/30d-total`,
    thirtyDaysChart: `${prefix}/dash/30d-chart`,
    monthly: `${prefix}/dash/{year}/{month}`,
    monthlyTotal: `${prefix}/dash/total/{year}/{month}`,
    monthlyChart: `${prefix}/dash/chart/{year}/{month}`,

    baseFreeUnlocked: `${prefix}/dash/base-free-unlocked`,
    baseRevenue: `${prefix}/dash/base-revenue`,
    baseHostessDeleted: `${prefix}/dash/base-hostess-deleted`,
    baseHostessValidated: `${prefix}/dash/base-hostess-validated`,
    basePrimeHistory: `${prefix}/dash/base-prime-history`,
    baseCreditHistory: `${prefix}/dash/base-credit-history`,
    baseHostessCancelledToValidated: `${prefix}/dash/base-cancelled-to-validated`,
    baseUserLeaveChart: `${prefix}/dash/base-leave/{user_type}`,
    baseUserLeaveItems: `${prefix}/dash/base-leave/{user_type}/{option_key}`,
    userStatConfirmed: `${prefix}/dash/user-stat-confirmed`,
    userStatFreeLikes: `${prefix}/dash/user-stat-free-likes`,
    userStatPerspective: `${prefix}/dash/user-stat-perspective`,
    userStatLids: `${prefix}/dash/user-stat-lids`,
    userStatKpiClients: `${prefix}/dash/user-stat-clients-kpi`,
    userStatKpiHostess: `${prefix}/dash/user-stat-hostess-kpi`
  },
  affiliateTest: `${prefix}/affiliates/test`,
  affiliateRecognize: `${prefix}/affiliates/{id}/recognize`,
  affiliateAggregateRecognized: `${prefix}/affiliates/{id}/aggregate-recognized`,
  affiliateCancelAggregateRecognized: `${prefix}/affiliates/{id}/cancel-aggregate-recognized`,
  media: {
    validate: `${prefix}/media/{id}/validate`,
    transform: `${prefix}/media/{id}/transform/{action}`,
    addAvatar: `${prefix}/media/{id}/add-avatar`,
    add: `${prefix}/media/{id}/add`,
    update: `${prefix}/media/{id}/update`,
    delete: `${prefix}/media/{id}/delete`
  },
  customers: {
    paymentApprove: `${prefix}/customers/{userId}/payments/{id}/approve`,
    noteAdd: `${prefix}/customers/{userId}/notes/add`,
    noteDelete: `${prefix}/customers/{userId}/notes/delete`,
    lockPassword: `${prefix}/customers/{userId}/lock-pwd`,
    unlockPassword: `${prefix}/customers/{userId}/unlock-pwd`,
    permanentDeleteList: `${prefix}/customers/{userId}/permanent-list`,
    permanentDelete: `${prefix}/customers/{userId}/permanent`,
    verifyEmail: `${prefix}/customers/{userId}/verify-email`,
    unverifyEmail: `${prefix}/customers/{userId}/unverify-email`,
    verifyMobile: `${prefix}/customers/{userId}/verify-mobile`,
    unverifyMobile: `${prefix}/customers/{userId}/unverify-mobile`,
    chartCredits: `${prefix}/customers/{userId}/chart-credits`,
    approveFreeLikeMessage: `${prefix}/customers/{userId}/free-like-message-approve`,
    declineFreeLikeMessage: `${prefix}/customers/{userId}/free-like-message-decline`,
    updateFreeLikeMessage: `${prefix}/customers/{userId}/free-like-message-update`,
    refreshSms: `${prefix}/customers/{userId}/sms/refresh`,
    batchSms: `${prefix}/customers/{userId}/sms/{batchId}`,
    log: `${prefix}/customers/{userId}/log/{type}`,
    media: `${prefix}/customers/{userId}/media`,
    mediaAdd: `${prefix}/customers/{userId}/media-add`,
    mediaValidateAll: `${prefix}/customers/{userId}/media-validate-all`,
    staffNotes: `${prefix}/customers/{userId}/staff-notes`,
    duplicates: `${prefix}/customers/{userId}/duplicates`,
    selfie: `${prefix}/customers/{userId}/selfie`,
    // [ID-338] Editorial ranking — dedicated save endpoint with reason
    editorialRanking: `${prefix}/customers/{userId}/editorial-ranking`
  },
  support: {
    index: `${prefix}/support`,
    show: `${prefix}/support/{id}`,
    read: `${prefix}/support/{id}/read`,
    messages: `${prefix}/support/{id}/messages`,
    messagesDelete: `${prefix}/support/{id}/messages/{messageId}`
  },
  task: {
    assign: `${prefix}/tasks/{id}/assign`,
    cancelAssignment: `${prefix}/tasks/{id}/cancel-assignment`,
    batch: `${prefix}/tasks/batch/{id}/update`
  },
  talks: {
    enableFeedback: `${prefix}/talks/enable-feedback/{id}`,
    deleteFeedback: `${prefix}/talks/delete-feedback/{id}`,
    refundTalk: `${prefix}/talks/refund-talk/{id}`,
    blockTalk: `${prefix}/talks/block-talk/{id}`,
    unlockTalk: `${prefix}/talks/unlock-talk/{id}`
  },
  settings: {
    payments: {
      base: `${prefix}/settings/payments`,
      data: `${prefix}/settings/payments/create`,
      modify: `${prefix}/settings/payments/{id}`
    },
    messages: {
      scamInfo: `${prefix}/settings/messages/scam-info`
      // , scamProcess: `${prefix}/settings/messages/scam-process`
    },
    hiddenProfiles: {
      index: `${prefix}/settings/hidden-profiles`
    }
  },
  reports: {
    users: {
      filterData: `${prefix}/reports/users/filter-data`,
      reportScv: `${prefix}/reports/users/csv`,
      reportXls: `${prefix}/reports/users/xls`,
      reportChartData: `${prefix}/reports/users-chart`,
      reportItemsData: `${prefix}/reports/users-items`
    },
    hostess: {
      filterData: `${prefix}/reports/hostess/filter-data`,
      reportScv: `${prefix}/reports/hostess/csv`,
      reportXls: `${prefix}/reports/hostess/xls`,
      reportData: `${prefix}/reports/hostess`
    },
    hostessChat: {
      filterData: `${prefix}/reports/hostess-chat/filter-data`,
      reportScv: `${prefix}/reports/hostess-chat/csv`,
      reportXls: `${prefix}/reports/hostess-chat/xls`,
      reportData: `${prefix}/reports/hostess-chat`
    },
    cities: {
      filterData: `${prefix}/reports/cities/filter-data`,
      reportScv: `${prefix}/reports/cities/csv`,
      reportXls: `${prefix}/reports/cities/xls`,
      reportData: `${prefix}/reports/cities`
    },
    payments: {
      filterData: `${prefix}/reports/payments/filter-data`,
      reportScv: `${prefix}/reports/payments/csv`,
      reportXls: `${prefix}/reports/payments/xls`,
      reportData: `${prefix}/reports/payments`
    }
  },
  search: {
    city: `${prefix}/search/city`,
    nationality: `${prefix}/search/nationality`,
    language: `${prefix}/search/language`,
    service: `${prefix}/search/service`,
    tag: `${prefix}/search/tag`
  },
  // for each repo we can specify methods:
  // index, show, create, update, delete or * to use all
  repository: {
    affiliates: ['*', 'filterData', 'search', { users: ['index'] }],
    tasks: ['index', 'update', 'filterData'],
    customers: [
      'index', 'show', 'edit', 'update', 'delete', 'filterData', 'search', 'export',
      {
        talks: ['index'],
        payments: ['index', 'filterData'],
        transactions: ['index', 'filterData'],
        reports: ['index', 'update', 'delete', 'filterData'],
        feedbacks: ['index', 'filterData'],
        invites: ['index', 'filterData'],
        notes: ['index', 'filterData'],
        sms: ['index', 'store', 'filterData']
      }
    ],
    users: ['*', 'filterData', 'search'],
    'users-leave': ['index', 'filterData'],
    faqs: ['*', 'filterData', 'search'],
    messages: ['index', 'filterData', 'search'],
    notes: ['index', 'filterData', 'search'],
    profileNotes: ['index', 'filterData', 'search'],
    promotions: ['index', 'create', 'store'],
    tec: ['show', 'edit', 'update'],
    talks: ['filterData', 'index', 'show', 'edit', { messages: ['index', 'update', 'delete'] }],
    settings: ['index', 'store', {
      payments: ['index', 'show', 'create', 'edit', 'store', 'update', 'delete', 'filterData']
    }]
  }
}
